import type { AxiosRequestConfig } from 'axios'
import type { ShippingAddress } from './cart'
import type { CheckoutPaymentMethod } from '~/lib/utils/payment-methods'

import { getRequest, postRequest } from '@lib/util/http'

import { BACKEND_URL } from '~/lib/config'
import { paymentController } from './consts'

// Request/Response Types
export interface PaymentRequest {
  // No amount field - calculated from user's cart on server
  shipping_address?: ShippingAddress
  method: CheckoutPaymentMethod
}

export interface RedsysFormData {
  url: string
  Ds_SignatureVersion: string
  Ds_MerchantParameters: string
  Ds_Signature: string
}

export interface PaymentResponse {
  data: RedsysFormData | null
}

export type CreatePaymentResponse = PaymentResponse | APIError

export type CreatePaymentPayload = PaymentRequest

export type CreatePaymentQuery = (
  orderId: string,
  paymentData: CreatePaymentPayload,
) => Promise<CreatePaymentResponse>

// API Functions
export async function createPayment(orderId: string, paymentData: PaymentRequest, axiosConfig: AxiosRequestConfig = {}) {
  const fetchURL = new URL(`${paymentController}pay/${orderId}`, BACKEND_URL)
  return postRequest<PaymentResponse, PaymentRequest>(
    fetchURL.href,
    paymentData,
    axiosConfig,
  )
}

// Order Status Types
export interface OrderStatusData {
  order_id: string
  status: 'pending' | 'paid' | 'failed' | 'not_found'
  amount?: number
  payment_date?: string
  auth_code?: string
  card_number?: string
  response_code?: string
}

export interface OrderStatusResponse {
  data: OrderStatusData
}

// Order Status API Function
export async function getOrderStatus(orderId: string, axiosConfig: AxiosRequestConfig = {}) {
  const fetchURL = new URL(
    `${paymentController}order/${orderId}/status`,
    BACKEND_URL,
  )
  return getRequest<OrderStatusResponse>(fetchURL.href, axiosConfig)
}
